import { defineMessages } from 'react-intl';

export default defineMessages({
    editProfile: {
        id: 'ri.editprofile.views.amp-users-profile.Edit Profile',
        defaultMessage: 'Edit Profile'
    },
    usrName: {
        id: 'ri.editprofile.views.amp-users-profile.Username',
        defaultMessage: 'Username'
    },
    firstName: {
        id: 'ri.editprofile.views.amp-users-profile.First Name',
        defaultMessage: 'First Name'
    },    
    lastName: {
        id: 'ri.editprofile.views.amp-users-profile.Last Name',
        defaultMessage: 'Last Name'
    },    
    email: {
        id: 'ri.editprofile.views.amp-users-profile.Email',
        defaultMessage: 'Email'
    },    
    cancelButton: {
        id: 'ri.editprofile.views.amp-users-profile.Cancel',
        defaultMessage: 'Cancel'
    },    
    saveButton: {
        id: 'ri.editprofile.views.amp-users-profile.Save',
        defaultMessage: 'Save'
    },    
    fieldEmpty: {
        id: 'ri.editprofile.views.amp-users-profile.Field Empty',
        defaultMessage: 'The field cannot be empty!'
    },
    successMessage: {
        id: 'ri.editprofile.views.amp-users-profile.Success Message',
        defaultMessage: 'The profile has been updated!'
    },   
    invalidEmail: {
        id: 'ri.editprofile.views.amp-users-profile.Invalid Email',
        defaultMessage: 'Email address is invalid!'
    },
    firstName1: {
        id: 'ri.editprofile.views.amp-users-profile.First Name1',
        defaultMessage: 'First Name is a required field!'
    },
    lastName1: {
        id: 'ri.editprofile.views.amp-users-profile.Last Name1',
        defaultMessage: 'Last Name is a required field!'
    },
});
